/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import './src/styles/global.css';

// import { trackPageChange } from './src/utils/userTracking';

// let lastPath = '';

// export const onRouteUpdate = ({ location }) => {
// 	if (lastPath !== location.pathname) {
// 		lastPath = location.pathname;
// 		// only track if path starts with /elearning
// 		if (
// 			location.pathname.startsWith('/elearning') ||
// 			location.pathname.startsWith('/ie/elearning/')
// 		) {
// 			trackPageChange(window.location.href);
// 		}
// 	}
// };

export const onClientEntry = () => {
	const gatsby_env = process.env.GATSBY_ENV;
	const hostname = window.location.hostname;

	// Define GTM container config with env-specific params
	const GTM_CONFIG = {
		local: {
			id: 'GTM-MBLFWL75',
			url: 'https://www.googletagmanager.com/gtm.js?id=GTM-MBLFWL75&gtm_auth=H2oGMFJyfIjA7re6LI74fQ&gtm_preview=env-6&gtm_cookies_win=x',
		},
		staging: {
			id: 'GTM-MBLFWL75',
			url: 'https://www.googletagmanager.com/gtm.js?id=GTM-MBLFWL75&gtm_auth=H2oGMFJyfIjA7re6LI74fQ&gtm_preview=env-6&gtm_cookies_win=x',
		},
		production: {
			id: 'GTM-MBLFWL75',
			url: 'https://www.googletagmanager.com/gtm.js?id=GTM-MBLFWL75',
		},
	};

	// Determine which config to use
	let config;
	if (hostname === 'localhost') {
		config = GTM_CONFIG.local;
	} else if (gatsby_env === 'staging' || gatsby_env === 'develop') {
		config = GTM_CONFIG.staging;
	} else {
		config = GTM_CONFIG.production;
	}

	let gtmLoaded = false;

	function loadGTM() {
		if (gtmLoaded) return;
		gtmLoaded = true;
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			const f = d.getElementsByTagName(s)[0];
			const j = d.createElement(s);
			const dl = l !== 'dataLayer' ? '&l=' + l : '';

			j.async = true;

			// Use custom URL if it contains GTM environment params
			if (config.url.includes('&gtm_auth')) {
				j.src = config.url;
			} else {
				j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			}

			// Preserve nonce if present
			const nonceTag = d.querySelector('[nonce]');
			if (nonceTag) {
				j.setAttribute(
					'nonce',
					nonceTag.nonce || nonceTag.getAttribute('nonce')
				);
			}

			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', config.id);
	}

	// Load GTM after user interaction
	const loadGTMOnce = () => {
		loadGTM();
		window.removeEventListener('scroll', loadGTMOnce);
		window.removeEventListener('mousemove', loadGTMOnce);
		window.removeEventListener('touchstart', loadGTMOnce);
	};

	window.addEventListener('scroll', loadGTMOnce, {
		once: true,
		passive: true,
	});
	window.addEventListener('mousemove', loadGTMOnce, {
		once: true,
		passive: true,
	});
	window.addEventListener('touchstart', loadGTMOnce, {
		once: true,
		passive: true,
	});

	// Fallback: load after 6 seconds
	setTimeout(loadGTM, 6000);
};

// // This code was used before setting up GTM environments.
// // Currently commented out as we are now using GTM environments.
// export const onClientEntry = () => {
// 	// Currently using a single GTM container, so this code is commented out for now.
// 	// GTM: Use the following environment variable to conditionally load or configure different GTM containers based on the environment.
// 	const gatsby_env = process.env.GATSBY_ENV;
// 	const hostname = window.location.hostname; // get current hostname
// 	// console.log('ENV:', gatsby_env, 'Hostname:', hostname);

// 	// TODO: Obtain the GTM container IDs for staging and production from Mahendra
// 	const GTM_CONTAINER_IDS = {
// 		local: 'GTM-TTKJKBVV', //use staging id
// 		staging: 'GTM-TTKJKBVV',
// 		production: 'GTM-TTKJKBVV',
// 	};

// 	// Load GTM container based on environment and hostname (local, staging/develop, or production).
// 	let containerId;

// 	if (hostname === 'localhost') {
// 		containerId = GTM_CONTAINER_IDS.local;
// 	} else if (gatsby_env === 'staging' || gatsby_env === 'develop') {
// 		containerId = GTM_CONTAINER_IDS.staging;
// 	} else {
// 		containerId = GTM_CONTAINER_IDS.production;
// 	}

// 	function loadGTM() {
// 		(function (w, d, s, l, i) {
// 			w[l] = w[l] || [];
// 			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
// 			var f = d.getElementsByTagName(s)[0],
// 				j = d.createElement(s),
// 				dl = l != 'dataLayer' ? '&l=' + l : '';
// 			j.async = true;
// 			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
// 			var n = d.querySelector('[nonce]');
// 			if (n) j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'));
// 			f.parentNode.insertBefore(j, f);
// 		})(window, document, 'script', 'dataLayer', 'GTM-TTKJKBVV'); //Get the new containerId from Mahendra
// 	}

// 	const loadGTMOnce = () => {
// 		loadGTM();
// 		window.removeEventListener('scroll', loadGTMOnce);
// 		window.removeEventListener('mousemove', loadGTMOnce);
// 		window.removeEventListener('touchstart', loadGTMOnce);
// 	};

// 	window.addEventListener('scroll', loadGTMOnce, {
// 		once: true,
// 		passive: true,
// 	});
// 	window.addEventListener('mousemove', loadGTMOnce, {
// 		once: true,
// 		passive: true,
// 	});
// 	window.addEventListener('touchstart', loadGTMOnce, {
// 		once: true,
// 		passive: true,
// 	});

// 	setTimeout(loadGTM, 6000);
// };

// GTM delay based on user idle time and device type - TEST 1
// export const onClientEntry = () => {
//   // Track if GTM has been loaded
//   let gtmLoaded = false;
//   let timeoutId = null;

//   function loadGTM() {
//     if (gtmLoaded) return;
//     gtmLoaded = true;

//     // Clear any pending timeout
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       timeoutId = null;
//     }

//     // Your GTM loading code
//     (function(w,d,s,l,i){
//       w[l]=w[l]||[];
//       w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
//       var f=d.getElementsByTagName(s)[0],
//           j=d.createElement(s),
//           dl=l!='dataLayer'?'&l='+l:'';
//       j.async=true;
//       j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
//       var n=d.querySelector('[nonce]');
//       if (n) j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'));
//       f.parentNode.insertBefore(j,f);
//     })(window,document,'script','dataLayer','GTM-TTKJKBVV');
//   }

//   // Unified loading function
//   const loadGTMOnce = () => {
//     if (!gtmLoaded) {
//       loadGTM();
//       // Remove all event listeners
//       window.removeEventListener('scroll', loadGTMOnce);
//       window.removeEventListener('mousemove', loadGTMOnce);
//       window.removeEventListener('touchstart', loadGTMOnce);
//       window.removeEventListener('click', loadGTMOnce);
//     }
//   };

//   // Add interaction listeners
//   const options = { passive: true };
//   window.addEventListener('scroll', loadGTMOnce, options);
//   window.addEventListener('mousemove', loadGTMOnce, options);
//   window.addEventListener('touchstart', loadGTMOnce, options);
//   window.addEventListener('click', loadGTMOnce, options);

//   // Set timeout based on device type
//   const isMobile = window.matchMedia("(max-width: 768px)").matches;
//   const delay = isMobile ? 6000 : 3000;

//   // Always use setTimeout for predictable behavior
//   timeoutId = setTimeout(loadGTMOnce, delay);
// };

// GTM delay based on 6s and user idle time [no device type] - TEST 2 [Working and Better Approach]
// export const onClientEntry = () => {
// 	let gtmLoaded = false;
// 	let timeoutId = null;

// 	function loadGTM() {
// 		if (gtmLoaded) return;
// 		gtmLoaded = true;

// 		// Clear the timeout if it exists
// 		if (timeoutId) clearTimeout(timeoutId);

// 		(function (w, d, s, l, i) {
// 			w[l] = w[l] || [];
// 			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
// 			var f = d.getElementsByTagName(s)[0],
// 				j = d.createElement(s),
// 				dl = l != 'dataLayer' ? '&l=' + l : '';
// 			j.async = true;
// 			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
// 			var n = d.querySelector('[nonce]');
// 			if (n) j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'));
// 			f.parentNode.insertBefore(j, f);
// 		})(window, document, 'script', 'dataLayer', 'GTM-TTKJKBVV');
// 	}

// 	const loadGTMOnce = () => {
// 		if (!gtmLoaded) {
// 			loadGTM();
// 		}
// 	};

// 	// More comprehensive interaction triggers
// 	const passiveOptions = { passive: true, once: true };
// 	window.addEventListener('scroll', loadGTMOnce, passiveOptions);
// 	window.addEventListener('touchstart', loadGTMOnce, passiveOptions);
// 	window.addEventListener('click', loadGTMOnce, passiveOptions); // Added click

//   // TEST 1
// 	// Connection-aware delay
// 	// const getDelay = () => {
// 	//   const conn = navigator.connection;
// 	//   if (conn?.saveData) return 10000; // Data saver mode
// 	//   if (conn?.effectiveType?.includes('2g')) return 8000;
// 	//   return 6000; // Default mobile delay
// 	// };

// 	// timeoutId = setTimeout(loadGTMOnce, getDelay());

//   // TEST 2
// 	// Connection-aware delay with visibility state check
// 	const getDelay = () => {
// 		// Don't load if tab is backgrounded
// 		if (document.visibilityState === 'hidden') return 15000;

// 		const conn = navigator.connection;
// 		if (conn?.saveData) return 10000; // Data saver mode
// 		if (conn?.effectiveType?.includes('2g')) return 8000;
// 		if (conn?.effectiveType?.includes('3g')) return 4000;
// 		return 6000; // Default delay for fast connections
// 	};

// 	// Only set timeout if page is visible
// 	if (document.visibilityState === 'visible') {
// 		timeoutId = setTimeout(loadGTMOnce, getDelay());
// 	}
// };

// Later: Load Facebook Pixel directly here and remove from GTM
// function loadFacebookPixel() {
//   if (window.fbq) return;

//   !(function(f,b,e,v,n,t,s){
//     if(f.fbq) return;
//     n=f.fbq=function(){
//       n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
//     };
//     if(!f._fbq) f._fbq=n;
//     n.push=n;
//     n.loaded=!0;
//     n.version='2.0';
//     n.queue=[];
//     t=b.createElement(e);
//     t.async=!0;
//     t.src=v;
//     s=b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t,s);
//   })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

//   fbq('init', '1704712936699095');
//   fbq('track', 'PageView');
// }

// function initFacebookPixelLazy() {
//   function onUserInteraction() {
//     loadFacebookPixel();
//     window.removeEventListener('scroll', onUserInteraction);
//     window.removeEventListener('mousemove', onUserInteraction);
//     window.removeEventListener('touchstart', onUserInteraction);
//   }

//   window.addEventListener('scroll', onUserInteraction, { once: true, passive: true });
//   window.addEventListener('mousemove', onUserInteraction, { once: true, passive: true });
//   window.addEventListener('touchstart', onUserInteraction, { once: true, passive: true });

//   if ('requestIdleCallback' in window) {
//     requestIdleCallback(loadFacebookPixel);
//   } else {
//     setTimeout(loadFacebookPixel, 6000);
//   }
// }

// // Call after setting GTM
// initFacebookPixelLazy();
